import { useEffect, useState } from "react";
export function useSheetContainer(mountPortalContainer) {
    const [container, setContainer] = useState(mountPortalContainer);
    useEffect(() => {
        if (!container) {
            const dialogElements = document.querySelectorAll(".s-sheet[role=dialog][data-state=open]");
            const lastDialog = dialogElements[dialogElements.length - 1];
            if (lastDialog) {
                setContainer(lastDialog);
            }
        }
    }, [container]);
    return container;
}
//# sourceMappingURL=useSheetContainer.js.map